import React, { memo, useMemo } from 'react';
import { BodyCell } from '@creditflowresearch/uilib/Table/DataTable';
import { ICategoryRow } from '@/creditflowresearch/application/League/interfaces';
import { useScorecardContext } from '@/creditflowresearch/application/League/Scorecard/ScorecardContext';

import tableRowStyles from '@/creditflowresearch/ui/components/filings/LoanLevel/LoanLevelTable/TableRow/tableRow.module.scss';
import alignStyles from '@creditflowresearch/uilib/styles/helpers/align.module.scss';
import standingStyles from '@/creditflowresearch/ui/components/league/Scorecard/StandingTable/standingTable.module.scss';

const getCount = ({ row }) => (<span className={ standingStyles.rankCell }>{ row.rank || '-' }</span>);

interface IProps extends ICategoryRow {
  rowIndex: number,
}

const TableRow = ({
  subCategoryId,
  categoryId,
  periods,
  rowIndex,
}: IProps) => {
  const { state } = useScorecardContext();
  const {
    columnState,
    expandedCategories,
  } = state;
  const {
    rankTableIndex: index,
    rankTableColumnCount: count,
  } = columnState;
  const isVisible = subCategoryId ? expandedCategories.includes(categoryId) : true;
  const sliceOfPeriods = useMemo(() => periods.slice(index, count + index), [periods, index, count]);

  if (!isVisible) {
    return null;
  }

  return (
    <tr className={ tableRowStyles.row } data-test={ `row[${ rowIndex }]` }>
      <td />
      { sliceOfPeriods.map((period) => (
        <BodyCell
          key={ period.name }
          name={ `count-${ period.name }` }
          className={ alignStyles.alignCenter }
          rowIndex={ rowIndex }
          rowData={ period }
          cellCallback={ getCount }
        />
      )) }
      <td />
    </tr>
  );
};

export default memo(TableRow);
